import React, { useState } from 'react';
import { Maximize2, Image as ImageIcon, Play } from 'lucide-react';
import Carousel from 'sushiweb/Carousel';
import { Modal } from '../../../../UiKit';
import { MultiMediaCarousel } from '../../../../UiKit/multimedia/multimedia';
import { MetricsForJumboEvent } from '../../../../analytics/constants';
import { CopilotUploadedImageViewClickEvent } from '../../../../analytics/copilot/events';

/**
 * "Uploaded Images" gallery, shared between the Complaint Identification
 * and Verification steps - a row of the customer's uploaded evidence
 * images with a zoom affordance that opens the same Modal+Carousel enlarged
 * view used for "View Complaint Images" (MerchantV1 -> OrderIssuesImagesV1
 * -> UiKit's MultiMedia), rather than reinventing a separate viewer.
 */
const UploadedImages = ({
  images = [],
  orderId = null,
  cartId = null,
  customerId = null,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleViewImage = (index) => {
    setActiveIndex(index);
    CopilotUploadedImageViewClickEvent({
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.cart_id]: cartId,
      [MetricsForJumboEvent.customer_id]: customerId,
      [MetricsForJumboEvent.feature_meta]: {
        image_id: images[index]?.id,
      },
    });
  };

  const carouselImages = images.map((image) => ({
    src: image.url,
    type: (image.type || 'image').toLowerCase(),
  }));

  return (
    <div className='tw-flex tw-flex-col tw-gap-[10px] tw-w-full'>
      <div className='tw-flex tw-items-center tw-justify-between tw-w-full'>
        <p className='tw-text-[14px] tw-leading-[18px] tw-font-medium tw-text-grey-800 tw-m-0'>
          Uploaded Images
        </p>
        {/* <Button
          variant='ghost-black'
          buttonType='default'
          size='sm'
          shape='square'
          rightIcon='arrow-forward'
          onClick={onViewProductDetails}
        >
          View Product Details
        </Button> */}
      </div>

      {images.length > 0 ? (
        <div className='tw-flex tw-gap-[12px] tw-items-center tw-w-full tw-overflow-x-auto tw-pb-1'>
          {images.map((image, index) => {
            const isVideo = (image.type || 'image').toLowerCase() === 'video';
            return (
              <div
                key={image.id}
                onClick={() => handleViewImage(index)}
                role='button'
                tabIndex={0}
                className='tw-relative tw-w-[84px] tw-h-[87px] tw-shrink-0 tw-rounded-[6px] tw-border tw-border-solid tw-border-[#e5e7eb] tw-overflow-hidden tw-bg-[#f3f4f6] tw-flex tw-items-center tw-justify-center tw-cursor-pointer'
              >
                {image.url ? (
                  isVideo ? (
                    <>
                      <video
                        src={image.url}
                        muted
                        className='tw-size-full tw-object-cover'
                      />
                      <div className='tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center'>
                        <Play
                          size={20}
                          className='tw-text-white tw-fill-white'
                        />
                      </div>
                    </>
                  ) : (
                    <img
                      src={image.url}
                      alt={image.alt || 'Uploaded evidence'}
                      className='tw-size-full tw-object-cover'
                    />
                  )
                ) : (
                  <ImageIcon size={20} className='tw-text-[#9da4ae]' />
                )}
                <div className='tw-absolute tw-top-[5px] tw-left-[5px] tw-bg-[rgba(46,46,46,0.53)] tw-rounded-[2px] tw-p-[1px] tw-flex tw-items-center tw-justify-center'>
                  <Maximize2 size={12} className='tw-text-white' />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className='tw-flex tw-items-center tw-gap-2 tw-text-[#9da4ae]'>
          <ImageIcon size={16} />
          <p className='tw-text-[12px] tw-m-0'>No images uploaded</p>
        </div>
      )}

      {activeIndex !== null && (
        <Modal
          isMaxContent
          maxHeight='82vh'
          isVisible={activeIndex !== null}
          type='large'
          title='Uploaded Images'
          handleClose={() => setActiveIndex(null)}
          containerStyles={{ padding: 'auto' }}
          component={
            <Carousel
              showComponent={true}
              componentData={carouselImages}
              componentToRender={MultiMediaCarousel}
              defaultTheme={false}
              currentIndex={activeIndex}
              dots={false}
              infinite={false}
              width='100%'
            />
          }
        />
      )}
    </div>
  );
};

export default UploadedImages;
